const ENABLED_MODULE_VALUES = [true, 1, '1', 'true']

export const PERIPHERAL_MODULE_KEYS = [
  'cable_transport',
  'camera',
  'voice',
  'transport_fuse',
  'parabola'
]

export function hasPlaneModule (plane, moduleName) {
  const modules = plane && plane.module
  return Boolean(modules && ENABLED_MODULE_VALUES.includes(modules[moduleName]))
}

export function hasPeripheralModule (plane) {
  return PERIPHERAL_MODULE_KEYS.some(moduleName => hasPlaneModule(plane, moduleName))
}
